export const formBuilderAssignmentsEndpoints = {
  assignments: "/form-builder/assignments",
  options: "/form-builder/assignments/options",
} as const;
